/**
 * A queued write was first sent longer ago than the server remembers its
 * idempotency key, and it may already have been applied: re-sending it could
 * apply it twice, so it is dropped instead (see `services/api/idempotencySends.ts`).
 */
export class StaleReplayError extends Error {
  constructor() {
    super("A change from over a day ago couldn't be confirmed, so it wasn't re-sent.")
    this.name = 'StaleReplayError'
  }
}
